"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import { useRef } from "react";
import parse from "html-react-parser";
import { SectionProps, HeadlineProps, ImageProps, ButtonProps, ProductProps } from "@/lib/types";
import useSWR from "swr";
import Product from "@/components/static/ProductCard";

//@ts-ignore
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

type Content = {
    headline: HeadlineProps;
    intro: string;
    image: ImageProps;
    settings: SectionProps & {
        justify: string;
        imagePos: string;
        product_cat: string[];
    };
    buttons: ButtonProps[];
    items: SlideProps[];
};

type SlideProps = {
    quote: string;
    headline: string;
};

export default function AdditionalProducts({
    content,
    productid,
}: {
    content: Content;
    productid: number;
}) {
    const excludedProductId = productid;

    const productCat =
        content.settings?.product_cat?.length > 0 ? content.settings.product_cat.at(0) : null;

    const apiUrl = `wp/v2/product?exclude=${excludedProductId}&acf_format=standard&per_page=100${
        productCat ? `&product_cat=${productCat}` : ""
    }`;

    const { data: productsData } = useSWR<ProductProps[]>(apiUrl, async (url: string) => {
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}${url}`);
        if (!response.ok) {
            throw new Error("Fehler beim Laden der Produkte");
        }
        return response.json();
    });
    const splideRef = useRef<any>(null);
    // const [activeSlide, setActiveSlide] = useState(0);
    // const [pageCount, setPageCount] = useState(1);

    // useEffect(() => {
    //     const updatePagination = () => {
    //         const splide = splideRef.current?.splide;
    //         if (splide) {
    //             const totalSlides = splide.length;
    //             const perPage = splide.options.perPage || 1;
    //             setPageCount(Math.ceil(totalSlides / perPage));
    //         }
    //     };

    //     updatePagination();

    //     window.addEventListener("resize", updatePagination);
    //     return () => window.removeEventListener("resize", updatePagination);
    // }, []);

    // const handleSlideChange = (splide: any) => {
    //     setActiveSlide(Math.floor(splide.index / splide.options.perPage));
    // };

    // const handlePaginationClick = (index: number) => {
    //     splideRef.current?.splide.go(index * (splideRef.current?.splide.options.perPage || 1));
    // };

    return (
        <>
            {content.settings.product_cat && content.settings.product_cat.length > 0 && (
                <Section
                    settings={content?.settings}
                    dataComponent='AdditionalProducts'
                    className='overflow-hidden'
                >
                    <div className='container'>
                        <div className='rb-12 mb-12 max-w-md md:mb-18 lg:mb-20'>
                            <Headline
                                tag={content.headline.tag}
                                align='start'
                                topline={content.headline.topline}
                            >
                                {content.headline.title}
                            </Headline>
                            {content.intro && (
                                <Text className='prose md:text-md'>{parse(content.intro)}</Text>
                            )}
                        </div>

                        <Splide
                            ref={splideRef}
                            hasTrack={false}
                            options={{
                                type: "slide",
                                drag: "free",
                                rewind: true,
                                gap: "32px",
                                autoWidth: true,
                                arrows: false,
                                pagination: false,
                                perPage: 3,
                                autoplay: true,
                                interval: 6000,
                                speed: 2000,
                                breakpoints: {
                                    576: { perPage: 1 },
                                    991: { perPage: 2 },
                                },
                            }}
                            // onMove={handleSlideChange}
                            className='!overflow-visible'
                        >
                            <SplideTrack className='!overflow-visible'>
                                {productsData?.map((item: ProductProps, index: number) => (
                                    <SplideSlide
                                        key={index}
                                        className='px-0 !overflow-visible w-full max-w-[320px]'
                                    >
                                        <Product post={item} />
                                    </SplideSlide>
                                ))}
                            </SplideTrack>
                        </Splide>

                        {/* <div className='custom-pagination py-[10px] px-6 bg-bgElement inline-flex rounded-full mt-16 gap-2'>
                    {Array.from({ length: pageCount }).map((_, index) => (
                        <button
                            key={index}
                            className={`flex items-center w-max ${
                                index === activeSlide ? "text-primary" : "text-primary"
                            }`}
                            onClick={() => handlePaginationClick(index)}
                        >
                            <div className='flex justify-center flex-col items-center'>
                                {index === activeSlide ? (
                                    <div className='h-4 rounded-full min-w-9 w-full bg-grey relative overflow-hidden'>
                                        <motion.div
                                            initial={{ width: "0%" }}
                                            animate={{ width: "100%" }}
                                            transition={{
                                                duration: 6,
                                                ease: "linear",
                                            }}
                                            className='rounded-full bg-stroke h-full'
                                        />
                                    </div>
                                ) : (
                                    <div
                                        className={`size-4 rounded-full ${
                                            index === activeSlide ? "bg-brand-dark" : "bg-grey"
                                        }`}
                                    ></div>
                                )}
                            </div>
                        </button>
                    ))}
                </div> */}
                    </div>
                </Section>
            )}
        </>
    );
}
